<div class="btn-toolbar">
  @if (!hideShowDocumentsButton) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_View_DocumentDetails'" [disabled]="selectedDataSourceItems.length <= 0" (click)="showDocuments()" id="showDocumentsButton">Show Documents</button>
    </div>
  }
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_Resend'" [disabled]="selectedDataSourceItems.length <= 0" (click)="reprocess()" id="reprocessButton">Reprocess</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_ManuallyHandle'" [disabled]="selectedDataSourceItems.length <= 0" (click)="handleManually()" id="manuallyHandleButton">Manually Handle</button>
  </div>
</div>

<dx-data-grid id="gridContainer"
  biz-grid
  exportFileName="Search Status Events Result"
  (onRefresh)="onRefresh()"
  [bizSetStateStoring]="false"
  [selection]='{ mode: "multiple" }'
  [showCollapseAllButton]="true"
  [bizSetScrolling]="false"
  [dataSource]='dataSourceItems'
  (onSelectionChanged)='selectionChanged($event)'
  bizRowsSelectedTemplate='rowsSelected'>
  <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
  <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="tracking-search-status-event-state" [savingTimeout]="500"></dxo-state-storing>

  <ng-container>
    <dxi-column dataField="StatusEventSubscriptionName" caption="Subscription Name" dataType="string" [visible]="true"></dxi-column>
    <dxi-column dataField="StatusEventSubscriptionDocumentStatusType" caption="Triggered By Document Status" dataType="string" [visible]="true"></dxi-column>
    <dxi-column dataField="DocumentStatusTriggerDate" caption="Trigger Date" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction" [visible]="true"></dxi-column>
    <dxi-column dataField="InterchangeInId" caption="Interchange In Id" dataType="number" [visible]="false"></dxi-column>
    <dxi-column dataField="DocumentId" caption="Document Id" dataType="number" [visible]="false"></dxi-column>
    <dxi-column dataField="StatusEventSubscriptionRunStatusType" caption="Run Status" dataType="string" [visible]="true"></dxi-column>
    <dxi-column dataField="StatusEventSubscriptionRunLatestActivityDate" caption="Run Status Date" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction" [visible]="true"></dxi-column>
  </ng-container>

  <div *dxTemplate="let data of 'rowsSelected'">
    <span style="margin-right: 4em; text-wrap: nowrap;">Number of selected rows: {{ data.counter.selectedRows }}</span>
  </div>

  <div *dxTemplate="let row of 'detail'">
    <app-status-events-detail-grid [statusEventSubscriptionRunId]="row.data.StatusEventSubscriptionRunId"></app-status-events-detail-grid>
  </div>

</dx-data-grid>
